"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidResponseError = void 0;
class InvalidResponseError extends Error {
    constructor(msg) {
        super(msg ? `InvalidResponseError: ${msg}` : "InvalidResponseError");
    }
}
exports.InvalidResponseError = InvalidResponseError;
//# sourceMappingURL=InvalidResponseError.js.map